import React from 'react';
import Col from 'react-bootstrap/Col';
import './Datazione.scss';
import { useLanguage } from '../../../LanguageContext';

const ArtworkDates = ({ currentArtwork, isArrayEmpty }) => {
  const { selectedLanguage } = useLanguage();
  const getLangValue = (data) => {
    return data ? data[selectedLanguage === 'it' ? 'it_IT' : 'en_GB'] : '';
  };

  // Una datazione per riga: testo libero (es. "XII sec.") oppure, se assente,
  // il range numerico data_inizio–data_fine; la nota tra parentesi.
  // Le righe completamente vuote vengono saltate (niente separatori spuri).
  const rows = (currentArtwork.dates || [])
    .slice()
    .sort((a, b) => (a.data_inizio || 0) - (b.data_inizio || 0))
    .map((date) => {
      const text = getLangValue(date.date);
      const note = getLangValue(date.date_note);
      const range = [date.data_inizio, date.data_fine]
        .filter((v) => v)
        .join(' – ');
      const main = text || range;
      if (!main && !note) return null;
      return { main, note };
    })
    .filter(Boolean);

  return (
    !isArrayEmpty(currentArtwork.dates) && rows.length > 0 && (
      <Col className="col-12 col-md-12">
        <label>
          <strong>{selectedLanguage === 'it' ? 'Datazione' : 'Dates'}</strong>
        </label>
        <Col className="col-12 col-md-12 boxField">
          {rows.map((row, index) => (
            <p key={index}>
              {row.main}
              {row.note && (row.main ? ` (${row.note})` : row.note)}
            </p>
          ))}
        </Col>
      </Col>
    )
  );
};

export default ArtworkDates;
